import { DateTime } from 'luxon';

export class DateFormatter {

    static createFromFormat(dateString: string, format: string): DateTime {
        return DateTime.fromFormat(dateString, format, {
            zone: 'UTC'
        });
    }

    static createFromISO(dateString: string): DateTime {
        return DateTime.fromISO(dateString);
    }

    static formatDate(dateTime: DateTime, format: string): string {
        dateTime = dateTime.setZone(Intl.DateTimeFormat().resolvedOptions().timeZone);

        return dateTime.toFormat(format)
    }

}